import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor(private http: HttpClient) { }

  form_incoming_data_leave_us_your_phone_number(
    id_form: any,
    name: any,
    email: any,
    phone1: any,
    phone2: any,
    timezone: any,
    url: any,
    country_code: any,
    browser: any,
    ip: any,
  ): Observable<any> {

    const body = {
      id_form: id_form,
      name: name,
      email: email,
      phone1: phone1,
      phone2: phone2,
      timezone: timezone,
      url: url,
      country_code: country_code,
      browser: browser,
      ip: ip,
    }
    return this.http.post('https://frontdoor.gybsupport.com:6969/forms/incoming_data', body);

  }


}
